// import './components/ns-loyalty-account-info/ns-loyalty-account-info.js';
import * as AccountService from './account-service.js';
import * as SignupService from './signupService.js';
import {account as a} from './nuskin.account.js';
import pack from '../package.json';

a.version = pack.version;

export let account = a;
export {default as AccountManager} from './nuskin.account.js';
export {default as AuthenticationService} from './authenticationService.js';
export {default as EmailService} from './emailService.js';
export {default as Buyer} from './buyer.js';
export {default as BuyerCookieService} from './buyerCookieService.js';
export {default as BuyerShippingInfo} from './buyerShippingInfo.js';
export {default as BuyerUserInfo} from './buyerUserInfo.js';
export {default as LegacyUserCookieService} from './legacyUserCookieService.js';
export {default as LoginService} from './loginService.js';
export {default as newAccount} from './newAccount.js';
export {default as ProfileService} from './profileService';
export {default as User} from './user.js';
export {default as UserCookieBaseService} from './userCookieBaseService.js';
export {default as UserCookieService} from './userCookieService.js';
export {default as userProfileManager} from './userProfileManager.js';
export {default as UserService} from './userService.js';
export {default as SigninMode} from './signinMode.js';
export {default as VGDistInfoService} from './vgDistInfoService.js';
export {default as ValidationService} from './validationService.js';
export {default as EquinoxService} from './equinox-service.js';
export { AccountService };
export { SignupService };
